"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaserBoxInnerGridL2SThumbnailsList = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../../_components/ui");
const _partials_1 = require("../_partials");
const TeaserBox_contracts_1 = require("../TeaserBox.contracts");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGridL2SThumbnailsList = class TeaserBoxInnerGridL2SThumbnailsList extends TeaserBox_contracts_1.TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.listConfig = {
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
        this.tileConfig = {
            [ui_1.TileSize.S]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showCategory: false,
                showAuthorAvatar: false,
                showAuthorName: false,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: ui_1.TileSize.S,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            },
            [ui_1.TileSize.L]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showCategory: this.teaserBoxConfig.showCategory,
                showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
                showAuthorName: this.teaserBoxConfig.showAuthorName,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: ui_1.TileSize.L,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            }
        };
        this.TileSize = ui_1.TileSize;
    }
};
TeaserBoxInnerGridL2SThumbnailsList.moduleVersion = TeaserBox_contracts_1.TeaserBoxVersion['L-2S-thumbnails-list'];
TeaserBoxInnerGridL2SThumbnailsList = __decorate([
    vue_property_decorator_1.Component({
        name: 'TeaserBoxInnerGridL2SThumbnailsList',
        components: { InnerGridWrapper: _partials_1.InnerGridWrapper, ThumbnailsList: ui_1.ThumbnailsList, Tile: ui_1.Tile },
        template: `
    <InnerGridWrapper>
      <template v-if="articles && articles.length">
        <!-- Tile / L -->
        <Tile v-bind="{ ...tileConfig[TileSize.L], fallbackImage, windowService, isLazy, isMobile }" :article="articles[0]" />

        <!-- Tiles / S -->
        <Tile v-for="article in articles.slice(1, 3)" :key="article.id"
              v-bind="{ ...tileConfig[TileSize.S], article, fallbackImage, windowService, isLazy, isMobile }" />

        <!-- ThumbnailsList -->
        <div class="teaser-box__list-wrapper">
          <ThumbnailsList v-bind="{ readMoreLink, fallbackImage, listConfig, windowService, isLazy, isMobile }" :articles="articles.slice(3, 9)" />
        </div>
      </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGridL2SThumbnailsList);
exports.TeaserBoxInnerGridL2SThumbnailsList = TeaserBoxInnerGridL2SThumbnailsList;
//# sourceMappingURL=L-2S-thumbnails-list.js.map